import { useCallback, useEffect, useState } from "react";

import useWindowDimensions from "./useWindowDimensions";

/**
 * Below BLOCK_BELOW the app shows the "use the mobile app" modal. Once narrow
 * it stays narrow until the viewport grows past RELEASE_ABOVE. The gap between
 * the two is deliberate hysteresis: without it, a window parked a pixel either
 * side of the line flips the modal on and off as the user nudges the edge.
 */
const BLOCK_BELOW = 560;
const RELEASE_ABOVE = 600;

const DISMISSED_KEY = "atiraspace_mobile_block_dismissed";

const readDismissed = () => {
  try {
    return window.sessionStorage.getItem(DISMISSED_KEY) === "1";
  } catch {
    return false;
  }
};

export function useIsViewportBlocked(): {
  blocked: boolean;
  width: number;
  dismiss: VoidFunction;
} {
  const { width } = useWindowDimensions();
  const [narrow, setNarrow] = useState(() => window.innerWidth < BLOCK_BELOW);
  const [dismissed, setDismissed] = useState(readDismissed);

  useEffect(() => {
    setNarrow((wasNarrow) =>
      wasNarrow ? width < RELEASE_ABOVE : width < BLOCK_BELOW,
    );
  }, [width]);

  const dismiss = useCallback(() => {
    try {
      window.sessionStorage.setItem(DISMISSED_KEY, "1");
    } catch {}
    setDismissed(true);
  }, []);

  return { blocked: narrow && !dismissed, width, dismiss };
}
